<ng-template #jamfPopover>Find your credentials on
  <a class="madero-link u_clickable" [href]="JAMF_URL" target="_blank">JAMF Pro</a>.
</ng-template>
<!-- TODO: update URL for Mosyle Support -->
<ng-template #mosylePopover>Find your credentials on
  <a class="madero-link u_clickable" [href]="JAMF_URL" target="_blank">Mosyle</a>.
</ng-template>
<ng-template #ssoUserProvisioningPopover>
  <span class="instructions">Enabling this setting manages users through your IdP and requires SSO for all users.</span><br/>
  <span class="instructions">Please confirm that all users have the appropriate user roles assigned through the IdP. Users who do not have user roles will not have access to Rise Vision.</span>
</ng-template>
<div class="tw-flex tw-flex-col xl:!tw-flex-row tw-gap-4">
  <div class="tw-flex tw-flex-col tw-flex-grow tw-gap-4">
    <div class="settings-page-section">
      <div id="errorBox" class="alert alert-danger" role="alert" [shown]="companyService.formError">
        <strong>{{companyService.formError}}</strong> {{companyService.apiError}}
        @if (companyService.isAddressError) {
          <suggest-general-delivery [addressObject]="companyService.company"></suggest-general-delivery>
        }
      </div>
      @if (company.id) {
        <div class="tw-mb-6 tw-flex tw-gap-6 tw-items-center tw-border-b tw-border-gray-200 tw-pb-4">
          <initials-badge [name]="companyService.company.name" [size]="48"></initials-badge>
          <div class="tw-flex-grow">
            <label for="company-name-input" style="padding-left: 4px;" class="control-label">Company Name</label>
            <stretchy-input
              id="company-name-input"
              [(value)]="companyService.company.name"
              name="companyName"
              ariaLabel="Edit company name"
            />
          </div>
            <a mat-stroked-button uiSref="apps.company.add" class="tw-font-medium">
              <mat-icon svgIcon="add"></mat-icon>
              Add Sub-Company
            </a>
        </div>
        <mat-divider class="-tw-mx-10 tw-mb-6 tw-border-gray-200"></mat-divider>
      }
      @else {
        <div class="form-group required" [ngClass]="{'has-error': (name.dirty || companyForm?.submitted) && name.invalid }">
          <label for="company-settings-name" class="control-label">
            Company Name
          </label>
          <input #name="ngModel" required id="company-settings-name" type="text" class="form-control" [(ngModel)]="company.name"
            name="name">
          <p [shown]="(name.dirty || companyForm?.submitted) && name.invalid"
            class="help-block validation-error-message-name text-danger">Company Name is required.</p>
        </div>
      }
      <div class="tw-flex tw-flex-col tw-gap-4">
        @if (company.id) {
          <div class="tw-flex tw-items-center tw-gap-6">
            <h2 class="tw-text-[16px] tw-mt-4 tw-font-semibold tw-text-gray-900">Contact Information</h2>
            <span><span class="tw-text-danger">*</span> Indicates a required field</span>
          </div>
        }
        <div class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-4 md:!tw-gap-8">
          <div class="form-group required tw-w-full"
            [ngClass]="{'has-error': (companyIndustry.dirty || companyForm?.submitted) && companyIndustry.invalid }">
            <label for="company-industry" class="control-label">
              Industry
            </label>
            <select #companyIndustry="ngModel" id="company-industry" class="form-control selectpicker"
              [disabled]="disableIndustry" [(ngModel)]="company.companyIndustry" name="companyIndustry" required>
              <option [value]="undefined" hidden>&lt; Select Industry &gt;</option>
              @for (industry of COMPANY_INDUSTRY_FIELDS; track industry) {
              <option value="{{industry[1]}}">{{industry[0]}}</option>
              }
            </select>
            <p [shown]="(companyIndustry.dirty || companyForm?.submitted) && companyIndustry.invalid"
              class="help-block validation-error-message-name text-danger">Please select an Industry.</p>
          </div>
          <div class="form-group tw-w-full">
            <label for="company-size" class="control-label">
              Company Size
            </label>
            <select #companySize name="companySize" id="company-size" class="form-control"
              [(ngModel)]="company.companySize">
              <option [value]="undefined" hidden>&lt; Select Size &gt;</option>
              @for (size of COMPANY_SIZE_FIELDS; track size) {
              <option value="{{size[1]}}">{{size[0]}}</option>
              }
            </select>
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-4 md:!tw-gap-8">
          <div class="form-group tw-w-full">
            <label for="company-settings-street" class="control-label">
              Street
            </label>
            <input #street id="company-settings-street" type="text" class="form-control"
              [(ngModel)]="company.street" name="street" autocomplete="street-address" />
          </div>
          <div class="form-group tw-w-full">
            <label for="company-settings-unit" class="control-label">
              Unit
            </label>
            <input #unit id="company-settings-unit" type="text" class="form-control" [(ngModel)]="company.unit"
              name="unit" autocomplete="address-line2" />
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-4 md:!tw-gap-8">
          <div class="form-group tw-w-full">
            <label for="company-settings-city" class="control-label">
              City
            </label>
            <input #city id="company-settings-city" type="text" class="form-control" [(ngModel)]="company.city"
              name="city" autocomplete="address-level2" />
          </div>
          <div class="form-group tw-w-full">
            <label for="company-settings-country" class="control-label">
              Country
            </label>
            <select #country id="company-settings-country" class="form-control selectpicker"
              [(ngModel)]="company.country" (change)="detectChanges()" name="country" autocomplete="country">
              <option [value]="undefined" hidden>&lt; Select Country &gt;</option>
              @for (c of countries; track c) {
              <option [value]="c.code" [disabled]="c.code === null">{{c.name}}</option>
              }
            </select>
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-4 md:!tw-gap-8">
          <div class="form-group tw-w-full">
            <label for="company-settings-state" class="control-label u_ellipsis u_align-top">
              State/Province/Region
            </label>
            @if (company.country !== 'US' && company.country !== 'CA') {
            <input #region id="company-settings-state" type="text" class="form-control"
              [(ngModel)]="company.province" name="province" autocomplete="address-level1" />
            }
            @else if (company.country === 'CA') {
            <select #province id="company-settings-state" class="form-control selectpicker" [(ngModel)]="company.province" name="province" autocomplete="address-level1">
              <option [value]="undefined" hidden>&lt; Select Province &gt;</option>
              @for (c of regionsCA; track c) {
              <option [value]="c[1]">{{c[0]}}</option>
              }
            </select>
            }
            @else if (company.country === 'US') {
            <select #state id="company-settings-state" class="form-control selectpicker" [(ngModel)]="company.province" name="province" autocomplete="address-level1">
              <option [value]="undefined" hidden>&lt; Select State &gt;</option>
              @for (c of regionsUS; track c) {
              <option [value]="c[1]">{{c[0]}}</option>
              }
            </select>
            }
          </div>
          <div class="form-group tw-w-full">
            <label for="company-settings-zip" class="control-label">
              ZIP/Postal Code
            </label>
            <input #postalCode id="company-settings-zip" type="text" class="form-control"
              [(ngModel)]="company.postalCode" name="postalCode" autocomplete="postal-code" />
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-4 md:!tw-gap-8">
          <div class="form-group tw-w-full" [ngClass]="{'has-error': website.errors?.pattern}">
            <label for="company-settings-website" class="control-label">
              Website
            </label>
            <input #website="ngModel" id="company-settings-website" name="website" type="text"
              placeholder="https://" class="form-control" [(ngModel)]="company.website" [pattern]="WEBSITE_REGEX" />
            <p [shown]="website.errors?.pattern" class="help-block validation-error-message-website text-danger">
              Please provide a valid URL. Example: https://www.example.com</p>
          </div>
          <div class="form-group tw-w-full" [ngClass]="{'has-error': telephone.errors?.pattern}">
            <label for="company-settings-phone" class="control-label">
              Phone Number
            </label>
            <input #telephone="ngModel" name="telephone" id="company-settings-phone" type="tel" class="form-control"
              [(ngModel)]="company.telephone" autocomplete="tel" [pattern]="PHONE_REGEX" />
            <p [shown]="telephone.errors?.pattern" class="help-block validation-error-message-phone text-danger">
              Please provide a valid phone number. Example: +15551234567</p>
          </div>
        </div>
        <div>
          <div class="form-group tw-w-full" [ngClass]="{'has-error': billingContactEmails.invalid}">
            <label for="billing-contact-emails" class="control-label">Billing Notifications Email</label>
            <emails-field #billingContactEmails="ngModel" name="billingContactEmails" id="billing-contact-emails"
              [(ngModel)]="company.billingContactEmails" [requireEmailsOnChange]="true"></emails-field>
            <p class="help-block text-danger" [shown]="billingContactEmails.errors?.emails">Please provide a valid
              email address. Example: billing&#64;company.com</p>
            <p class="help-block text-danger" [shown]="billingContactEmails.errors?.requireEmails">Please enter at least
              one email address.</p>
          </div>
        </div>
      </div>
    </div>
    @if (showManagedSections) {
      <div class="settings-page-section">
        <div class="row">
          <div class="col-md-12">
            <div class="pl-4 pr-4 pt-4">
              <div class="row">
                <div class="col-md-6 pr-5">
                  <div class="form-group">
                    <label class="tw-font-semibold" for="resetAuthKey">
                      Authentication Key
                    </label>
                    <button type="button" class="action-link ml-2 pull-right tw-border-none tw-bg-transparent tw-text-blue-600 tw-underline ps-reset-auth-key" id="resetAuthKey"
                      (click)="resetAuthKey()" aria-label="Reset Authentication Key">Reset</button>
                    <div class="ps-auth-key">
                      {{company.authKey}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pr-5">
                  <div class="form-group">
                    <label class="tw-font-semibold" for="claimId">
                      Claim ID
                    </label>
                    <button type="button" class="action-link ml-2 pull-right tw-border-none tw-bg-transparent tw-text-blue-600 tw-underline ps-reset-claim-id" id="claimId"
                      (click)="resetClaimId()" aria-label="Reset Claim ID">Reset</button>
                    <div class="ps-claim-id">
                      {{company.claimId}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (showManagedSections) {
  <div class="tw-flex-grow xl:!tw-max-w-xs tw-min-w-[372px]">
    <div class="settings-page-section">
      <div>
        <div>
          <div>
            <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">FUSE Display Management</h2>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="flex-row left-right-aligner">
              <label id="company-settings-fuseenabled-label" for="company-settings-fuseenabled" class="control-label tw-font-normal" (click)="company.settings.fuseEnabled = !company.settings.fuseEnabled; updateEditableFields()">
                Enable Avocor FUSE
              </label>
              <mat-slide-toggle class="mb-2" name="fuseEnabled" id="company-settings-fuseenabled"
                [(ngModel)]="company.settings.fuseEnabled"
                (change)="updateEditableFields()" [attr.aria-pressed]="company.settings.fuseEnabled">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        @if (company.settings.fuseEnabled) {
        <div>
          <div class="pt-3 border-top">
            <div class="form-group">
              <label for="company-settings-fuseapikey" class="control-label tw-font-normal">
                FUSE API Key
              </label>
              <div class="flex-row left-right-aligner">
                <input id="company-settings-fuseapikey" name="company-settings-fuseapikey" #fuseapikey="ngModel"
                  required type="text" class="form-control" placeholder="API Key" [readonly]="!fuseApiKeyEditable"
                  [(ngModel)]="company.settings.fuseApiKey">
                @if (!fuseApiKeyEditable) {
                <button aria-label="Edit FUSE API Key" class="btn btn-default-icon pl-3 pr-3 ml-2"
                  (click)="editFuseApiKey()">
                  <streamline-icon name="pencil" width="12" height="12"></streamline-icon>
                </button>
                }
              </div>
              <p [shown]="(fuseapikey.dirty || companyForm?.submitted) && fuseapikey.errors?.required"
                class="help-block validation-error-message-name text-danger">FUSE API Key is required.</p>
            </div>
          </div>
          <div class="tw-mb-8">
            <span class="instructions">
              Enter your API Key from <a href="https://fuse.avocor.com/settings/api_keys?page=1"
                target="_blank">https://fuse.avocor.com/settings/api_keys?page=1</a>
            </span>
          </div>
        </div>
        }
        <mat-divider class="-tw-mx-10 tw-mb-6 tw-border-gray-100"></mat-divider>
        <div class="row">
          <div class="col-md-12 mb-2">
            <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">Apple TV MDM</h2>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="flex-row left-right-aligner">
              <label id="company-settings-jamfenabled-label" for="company-settings-jamfenabled" class="control-label tw-font-normal" (click)="company.settings.jamfEnabled = !company.settings.jamfEnabled; updateEditableFields()">
                Enable JAMF Pro
                <streamline-icon tabindex="0" name="help" class="help" [outsideClick]="true" [popover]="jamfPopover"
                  triggers="mouseenter:click focus:click" (keyup.enter)="redirect()"
                  ariaLabel="Show Enable JAMF Pro Tooltip" role="tooltip" id="jamf-tooltip">
                </streamline-icon>
              </label>
              <mat-slide-toggle tabindex="0" class="mb-2" name="jamfEnabled" id="company-settings-jamfenabled"
                aria-describedby="jamf-tooltip" [(ngModel)]="company.settings.jamfEnabled"
                (change)="updateEditableFields()" [disabled]="company.settings.mosyleEnabled" [attr.aria-pressed]="company.settings.jamfEnabled" [attr.aria-disabled]="company.settings.mosyleEnabled">
              </mat-slide-toggle>
            </div>
          </div>
        </div>

        <div class="tw-mb-8">
          <div class="flex-row left-right-aligner">
            <label id="company-settings-mosyleenabled-label" for="company-settings-mosyleenabled" class="control-label tw-font-normal" (click)="company.settings.mosyleEnabled = !company.settings.mosyleEnabled; updateEditableFields()">
              Enable Mosyle
              <streamline-icon tabindex="0" name="help" class="help" [outsideClick]="true" [popover]="mosylePopover"
                triggers="mouseenter:click focus:click" (keyup.enter)="redirect()"
                ariaLabel="Show Enable Mosyle Tooltip" role="tooltip" id="mosyle-tooltip">
              </streamline-icon>
            </label>
            <mat-slide-toggle tabindex="0" class="mb-2" name="mosyleEnabled" id="company-settings-mosyleenabled"
              aria-describedby="mosyle-tooltip" [(ngModel)]="company.settings.mosyleEnabled"
              (change)="updateEditableFields()" [disabled]="company.settings.jamfEnabled" [attr.aria-pressed]="company.settings.mosyleEnabled" [attr.aria-disabled]="company.settings.jamfEnabled">
            </mat-slide-toggle>
          </div>
        </div>
        @if (company.settings.mosyleEnabled) {
        <div class="border-top tw-pt-8 tw-pb-4">
          <div class="form-group">
            <label for="company-settings-mosyleadminemail" class="control-label tw-font-normal">
              Admin Email
            </label>
            <input id="company-settings-mosyleadminemail" name="company-settings-mosyleadminemail"
              #mosyleadminemail="ngModel" required type="text" class="form-control" [pattern]="EMAIL_REGEX"
              placeholder="Admin Email" [(ngModel)]="company.settings.mosyleEmail">
            <p [shown]="(mosyleadminemail.dirty || companyForm?.submitted) && mosyleadminemail.errors?.required"
              class="help-block validation-error-message-admin-email text-danger">Mosyle Admin Email is required.</p>
            <p [shown]="(mosyleadminemail.dirty || companyForm?.submitted) && mosyleadminemail.errors?.pattern"
              class="help-block validation-error-message-admin-email text-danger">Mosyle Admin Email is invalid.</p>
          </div>
          <div class="form-group">
            <label for="company-settings-mosylepassword" class="control-label tw-font-normal">
              Password
            </label>
            <input id="company-settings-mosylepassword" name="company-settings-mosylepassword"
              #mosylepassword="ngModel" required type="password" class="form-control" placeholder="Password"
              [(ngModel)]="company.settings.mosylePassword">
            <p [shown]="(mosylepassword.dirty || companyForm?.submitted) && mosylepassword.errors?.required"
              class="help-block validation-error-message-password text-danger">Mosyle Password is required.</p>
          </div>
          <div class="form-group">
            <label for="company-settings-mosyleaccesstoken" class="control-label tw-font-normal">
              Access Token
            </label>
            <div class="flex-row left-right-aligner">
              <input id="company-settings-mosyleaccesstoken" name="company-settings-mosyleaccesstoken"
                #mosyleaccesstoken="ngModel" required type="text" class="form-control" placeholder="Access Token"
                [readonly]="!mosyleAccessTokenEditable" [(ngModel)]="company.settings.mosyleAccessToken">
              @if (!mosyleAccessTokenEditable) {
              <button attr.aria-label="Edit mosyle access token" class="btn btn-default-icon pl-3 pr-3 ml-2"
                (click)="editMosyleAccessToken()">
                <streamline-icon name="pencil" width="12" height="12"></streamline-icon>
              </button>
              }
            </div>
            <p [shown]="(mosyleaccesstoken.dirty || companyForm?.submitted) && mosyleaccesstoken.errors?.required"
              class="help-block validation-error-message-access-token text-danger">Mosyle Access Token is required.
            </p>
          </div>
        </div>
        }
        @if (company.settings.jamfEnabled) {
        <div class="border-top tw-pt-8 tw-pb-4">
          <div class="form-group">
            <label for="company-settings-jamfdomain" class="control-label tw-font-normal">
              JAMF Pro Server
            </label>
            <input id="company-settings-jamfdomain" name="company-settings-jamfdomain" #jamfdomain="ngModel" required
              type="text" class="form-control" [pattern]="WEBSITE_REGEX" placeholder="Domain"
              [(ngModel)]="company.settings.jamfDomain">
            <p [shown]="(jamfdomain.dirty || companyForm?.submitted) && jamfdomain.errors?.required"
              class="help-block validation-error-message-domain text-danger">Jamf Domain is required.</p>
            <p [shown]="(jamfdomain.dirty || companyForm?.submitted) && jamfdomain.errors?.pattern"
              class="help-block validation-error-message-domain text-danger">Jamf Domain is invalid.</p>
          </div>
          <div class="form-group">
            <label for="company-settings-jamfclientid" class="control-label tw-font-normal">
              Client ID
            </label>
            <input id="company-settings-jamfclientid" name="company-settings-jamfclientid" #jamfclientid="ngModel"
              required type="text" class="form-control" placeholder="Client Id"
              [(ngModel)]="company.settings.jamfClientId">
            <p [shown]="(jamfclientid.dirty || companyForm?.submitted) && jamfclientid.errors?.required"
              class="help-block validation-error-message-client-id text-danger">Jamf Client Id is required.</p>
          </div>
          <div class="form-group">
            <label for="company-settings-jamfclientsecret" class="control-label tw-font-normal">
              Client Secret
            </label>
            <div class="flex-row left-right-aligner">
              <input id="company-settings-jamfclientsecret" name="company-settings-jamfclientsecret"
                #jamfclientsecret="ngModel" required type="text" class="form-control" placeholder="Client Secret"
                [readonly]="!jamfSecretEditable" [(ngModel)]="company.settings.jamfClientSecret">
              @if (!jamfSecretEditable) {
              <button attr.aria-label="Edit JAMF client secret" class="btn btn-default-icon pl-3 pr-3 ml-2"
                (click)="editJamfSecret()">
                <streamline-icon name="pencil" width="12" height="12"></streamline-icon>
              </button>
              }
            </div>
            <p [shown]="(jamfclientsecret.dirty || companyForm?.submitted) && jamfclientsecret.errors?.required"
              class="help-block validation-error-message-name text-danger">Jamf Client Secret is required.</p>
          </div>
        </div>
        }
        @if (isRiseStoreAdmin && showManagedSections) {
        <mat-divider class="-tw-mx-10 tw-mb-6 tw-border-gray-100"></mat-divider>
        <div>
          <div class="row">
            <div class="col-md-12">
              <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">Rise Admin Only</h2>
            </div>
          </div>
          @if (company.isTest) {
          <div class="flex-row left-right-aligner mt-3">
            <label id="is-test-label" for="is-test" class="rise-admin-only tw-font-normal" (click)="company.isTest = !company.isTest">Test Company</label>
            <mat-slide-toggle name="isTest" id="is-test" class="mb-2"
              [(ngModel)]="company.isTest" [disabled]="true" [attr.aria-pressed]="company.isTest" [attr.aria-disabled]="true">
            </mat-slide-toggle>
          </div>
          }
          @if (!currentPlanService.isUnlimitedPlan()) {
          <div class="flex-row left-right-aligner mt-3">
            <label id="share-company-plan-label" for="share-company-plan" class="rise-admin-only tw-font-normal" (click)="company.shareCompanyPlan = !company.shareCompanyPlan">Share Company Plan</label>
            <mat-slide-toggle name="shareCompanyPlan" id="share-company-plan"
              class="mb-2" [(ngModel)]="company.shareCompanyPlan" [disabled]="disableSharePlanToggle()" [attr.aria-pressed]="company.shareCompanyPlan" [attr.aria-disabled]="disableSharePlanToggle()">
            </mat-slide-toggle>
          </div>
          }
          @if (currentPlanService.isUnlimitedPlan()) {
          <div class="flex-row left-right-aligner mt-3">
            <label id="share-unlimited-plan-label" for="share-unlimited-plan" class="rise-admin-only tw-font-normal" (click)="company.shareUnlimitedPlan = !company.shareUnlimitedPlan">Share Unlimited Plan</label>
            <mat-slide-toggle name="shareUnlimitedPlan" id="share-unlimited-plan"
              class="mb-2" [(ngModel)]="company.shareUnlimitedPlan" [disabled]="disableSharePlanToggle()" [attr.aria-pressed]="company.shareUnlimitedPlan" [attr.aria-disabled]="disableSharePlanToggle()">
            </mat-slide-toggle>
          </div>
          }
          @if (!(currentPlanService.isUnlimitedPlan() && currentPlanService.isSubscribed())) {
          <div class="flex-row left-right-aligner mt-3">
            <label id="unlock-all-features-label" for="unlock-all-features" class="rise-admin-only tw-font-normal" (click)="company.unlockAllFeatures = !company.unlockAllFeatures">Unlock All
              Features</label>
            <mat-slide-toggle name="unlockAllFeatures" id="unlock-all-features"
              class="mb-2" [(ngModel)]="company.unlockAllFeatures" [attr.aria-pressed]="company.unlockAllFeatures">
            </mat-slide-toggle>
          </div>
          }
        </div>
        }
      </div>
    </div>

    @if (!isRiseRootCompany) {
      <div class="settings-page-section tw-mt-[16px]">
        <div>
          <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-2">
            <div class="tw-flex tw-flex-row tw-items-center">
              <label
                id="allow-sub-company-reviews-label"
                for="allow-sub-company-reviews"
                class="control-label tw-text-[14px] tw-font-semibold tw-text-gray-900 tw-m-0"
              >
                Allow sub-company reviews
              </label>
              @if (!isPublicationApprovalAvailable) {
                <button
                  aria-label="Upgrade Publishing Approval"
                  mat-icon-button
                  type="button"
                  (click)="showPublishingApprovalUpgradePlanModal()"
                >
                  <mat-icon class="small" svgIcon="requires-upgrade"></mat-icon>
                </button>
              }
            </div>
            <mat-slide-toggle
              name="allowSubCompanyReviews"
              id="allow-sub-company-reviews"
              [(ngModel)]="company.settings.allowSubCompanyReviewers"
              [disabled]="!isPublicationApprovalAvailable"
              aria-labelledby="allow-sub-company-reviews-label"
              aria-describedby="allow-sub-company-reviews-help"
            >
            </mat-slide-toggle>
          </div>
          <p id="allow-sub-company-reviews-help" class="tw-text-gray-500 tw-pt-[8px] tw-text-[13px]">Let Content Editors in sub-companies send review requests to your company's Publishers.</p>
        </div>
      </div>
    }
  </div>
  }
</div>